import {EnumModel} from '../models/EnumModel';
import {HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';

export class ProjectConstants  {

  PROJECT_VERSION = '1.0';
  PROJECT_NAME    = 'CoBiDB';
  CLIENT_NAME     = 'Generic';

  USER_ID = 'userId';

  PROVIDER_DXC = 'DXC';
  PROVIDER_IBM = 'IBM';

  CONTRACT_TYPE_BASE_CHARGES_ADAS = 'Base Charges ADAS Contract';
  CONTRACT_TYPE_ULB_CHARGES_ADAS = 'ULB Charges ADAS Contract';

  CHARGING_METHODOLOGY = {
    PRICE_RANGE: 'PRICE RANGE',
    PXQ: 'PxQ',
    ARC_RRC: 'ARC/RRC',
    FIXED: 'FIXED'
  };

  SESSION_STORAGE_LABELS = {
    CONTRACTUAL_VALUES_FILTER: 'contractualValuesFilter',
    ARC_RRC_FILTER: 'arcRrcFilter',
    TERMINATION_FEE_FILTER: 'terminationFeeFilter',
    DISCOUNT_FILTER: 'discountFilter',
    MINIMUM_COMMITMENT_FILTER: 'minimumCommFilter',
    REIMBURSMENT_FILTER: 'reimbursmentFilter',
    TRANSFORMATION_FILTER: 'transformationFilter',
    RATE_CARD_FILTER: 'rateCardFilter',
    DELTA_VOLUMES_FILTER: 'deltaVolumiFilter',
    FORECAST_VOLUMES_FILTER: 'forecastVolumiFilter',
    VOLUME_CONSUMPTIVE_FILTER: 'consuntivoVolumiFilter',
    SERVICE_CHANGES_FILTER: 'serviceChangeFilter',
    CALCULATED_CHARGE_FILTER: 'calculatedChargeFilter',
    DELTA_CHARGES_FILTER: 'deltaChargesFilter',
    CONSUMPTIVE_CHARGES_FILTER: 'consuntivoChargesFilter',
    LOCAL_CUSTOMER_SETTINGS_FILTER: 'localCustomerSettingFilter',
    CONTRACT_SETTING_FILTER: 'contractSettingFilter',
    ARCHITECTURE_STRUCTURE_SETTING_FILTER: 'architectureStructureSettingFilter',
    CURRENCY_SETTING_FILTER: 'currencySettingFilter',
    DEFAULT_PROVIDER_SELECTED: 'providerDefaultSelected'
  };

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  CSV_TYPE = 'application/vnd.ms-excel';

  LINKS = {
    LOGIN: '/login',
    HOMEPAGE:   '/homepage',
    CONTRACTUAL_DATA: '/contractual-data',
    MONTHLY_ACTUAL: '/monthly-actual',
    SERVICE_CHANGES: '/service-changes',
    MONTHLY_CHARGES: '/monthly-charges',
    RECOVERY_MANAGEMENT: '/recovery-management',
    REPORTING: '/reporting',
    DASHBOARD: '/dashboard',
    SETTINGS: '/settings',
    MASTER_DATA: '/master-data',
    USERS: '/users',
    TERMINATION_FEE: '/termination-fee',
    NEW_RESOURCE_UNITS_ANAGRF : '/new-resources-units-anagraf',
    NEW_REGION_ANAGRF: '/new-region-anagraf',
    EDIT_REGION_ANAGRF: '/edit-region-anagraf',
    EDIT_LOCAL_CUSTOMER_ANAGRF: '/edit-local-customer-anagraf',
    EDIT_LOCAL_CUSTOMER_SETTINGS: '/edit-local-customer-settings',
    EDIT_RESOURCE_UNITS_ANAGRF: '/edit-resource-unit-anagraf',
    EDIT_UNITS_ANAGRF: '/edit-units-anagraf',
    NEW_CONTRACT_TYPE_ANAGRF: '/new-contract-type-anagraf',
    NEW_PROVIDER_ANAGRF: '/new-provider-anagraf',
    EDIT_CONTRACT_TYPE_ANAGRF: '/edit-contract-type-anagraf',
    EDIT_CONTRACT_TYPE_SETTINGS: '/edit-contract-type-settings',
    EDIT_PROVIDER_ANAGRF: '/edit-provider-anagraf',
    NEW_RATE_TYPE__ANAGRF: '/new-rate-type-anagraf',
    EDIT_RATE_TYPE__ANAGRF: '/edit-rate-type-anagraf',
    NEW_ROLE_ANAGRAF: '/new-role-anagraf',
    EDIT_ROLE_ANAGRF: '/edit-role-anagraf',
    NEW_SIZE_ANAGRF: '/new-size-anagraf',
    EDIT_SIZE_ANAGRF: '/edit-size-anagraf',
    NEW_SITE_ANAGRF: '/new-site-anagraf',
    EDIT_SITE_ANAGRF: '/edit-site-anagraf',
    NEW_ORGANIZATION_UNIT_ANAGRF: '/new-organization-unit-anagraf',
    EDIT_ORGANIZATION_UNIT_ANAGRF: '/edit-organization-unit-anagraf',
    NEW_LOCAL_CUSTOMER_ANAGRF: '/new-local-customer-anagraf',
    NEW_LOCAL_CUSTOMER: '/new-local-customer',
    NEW_DISCOUNT: '/new-discount',
    NEW_DISCOUNT_MASSIVE: '/new-discount-massive',
    NEW_MINIMUM_COMM: '/new-minimum-comm',
    NEW_CURRENCY: '/new-currency',
    NEW_CONTRACT: '/new-contract',
    NEW_ARCHITECTURE_STRUCTURE: '/new-architecture-structure',
    EDIT_ARCHITECTURE_STRUCTURE: '/edit-architecture-structure',
    NEW_SL1_ANAGRF: '/new-sl1-anagraf',
    EDIT_SL1_ANAGRF: '/edit-sl1-anagraf',
    NEW_SL2_ANAGRF: '/new-sl2-anagraf',
    EDIT_SL2_ANAGRF: '/edit-sl2-anagraf',
    NEW_SL3_ANAGRF: '/new-sl3-anagraf',
    EDIT_SL3_ANAGRF: '/edit-sl3-anagraf',
    NEW_SL4_ANAGRF: '/new-sl4-anagraf',
    EDIT_SL4_ANAGRF: '/edit-sl4-anagraf',
    NEW_SL5_ANAGRF: '/new-sl5-anagraf',
    EDIT_SL5_ANAGRF: '/edit-sl5-anagraf',
    NEW_UNITS_ANAGRF: '/new-units-anagraf',
    NEW_CURRENCY_ANAGRF: '/new-currency-anagraf',
    EDIT_CURRENCY_ANAGRF: '/edit-currency-anagraf',
    NEW_SHARENAME_DEVICE_ANAGRF: '/new-sharename-device-anagraf',
    EDIT_SHARENAME_DEVICE_ANAGRF: '/edit-sharename-device-anagraf',
    NEW_SERVICE_VARIANT_ANAGRF: '/new-service-variant-anagraf',
    EDIT_SERVICE_VARIANT_ANAGRF: '/edit-service-variant-anagraf',
    EDIT_CURRENCY_SETTINGS: '/edit-currency-setting',
    EDIT_DISCOUNT: '/edit-discount',
    EDIT_DISCOUNT_MASSIVE: '/edit-discount-massive',
    NEW_CONTRACTUAL_DATA : '/new-contractual-values',
    NEW_CONTRACTUAL_DATA_MASSIVE: '/new-contractual-values-massive',
    EDIT_CONTRACTUAL_DATA: '/edit-contractual-values',
    EDIT_CONTRACTUAL_DATA_MASSIVE: '/edit-contractual-values-massive',
    EDIT_RATE_CARD: '/edit-rate-card',
    NEW_RATE_CARD: '/new-rate-card',
    EDIT_REIMBURSMENT: '/edit-reimbursment',
    NEW_REIMBURSMENT: '/new-reimbursment',
    EDIT_TERMINATION_FEE: '/edit-termination-fee',
    NEW_TERMINATION_FEE: '/new-termination-fee',
    EDIT_TRANSFORMATION: '/edit-transformation',
    NEW_SERVICE_CHANGES: '/new-service-changes',
    NEW_SERVICE_CHANGES_MASSIVE: '/new-service-changes-massive',
    NEW_USERS: '/new-users',
    EDIT_SERVICE_CHANGES: '/edit-service-changes',
    EDIT_SERVICE_CHANGES_MASSIVE: '/edit-service-changes-massive',
    EDIT_USERS: '/edit-users',
    EDIT_MINIMUM_COMM: '/edit-minimum-comm',
    NEW_DELTA_VOLUMES: '/new-delta-volumi',
    NEW_DELTA_VOLUMES_DET: '/new-delta-volumi-det',
    GET_ALL_MONTH: '/allMonth',
    GET_QUARTER_MONTH: '/allQuarterMonth',
    GET_ALL_YEAR: '/allYear',
    GET_FIRST_YEAR: '/firtsYear',
    GET_FIRST_MONTH: '/firtsMonth',
    GET_LAST_CONSUMPTIVE_VOL_MONTH: '/lastConsumptiveVolMonth',
    GET_LAST_CONSUMPTIVE_CHARGE_MONTH: '/lastConsumptiveChargeMonth',
    GET_CONSOLIDATE_MONTH_BY_PROV: '/getConsolidateMonthByProvider',
    GET_USER_BY_USERNAME: '/getUserByUserName',
    GET_USER_SECTION_GRANT: '/getUserSectionGrant',
    CHANGES_UPLOAD: '/changes-upload',
    GET_LIST: '/selectAll',

    DETAIL:   '/detail/',
    EDIT:     '/edit/',
    LIST:     '/list',
    NEW:      '/new',
    UPDATE: '/update',
    SOFT_DELETE: '/softDelete/',
    HARD_DELETE: 'delete/',
    PAGE:     '/page',
    PAGE_IN_LOCAL_CUSTOMER_SETTING:   '/pageInLocalCustomerSettings',
    PAGE_IN_ALL_SETTING:   '/pageInAllSettings',
    LIST_IN_ARCHITECTURE_STRUCTURE: '/listInArchitectureStructure',
    LIST_IN_LOCAL_CUSTOMER_SETTING: '/listInLocalCustomerSetting',
    LIST_IN_CONTRACT_TYPE_SETTING: '/listInContractTypeSetting',
    LIST_IN_CURRENCY_SETTING: '/listInCurrencySetting',
    PAGE_IN_ALL_CONTRACT_MONTH: '/pageInAllContractMonth',
    PAGE_WITH_LIST: '/pageWithList',
    MULTI_INSERT: '/multiInsert',
    MULTI_UPDATE: '/multiUpdate',
    UPDATE_ALL_CLAIMS: '/udpateAllClaims',
    DOWNLOAD_CSV: '/downloadCSV',
    GENERATE_CSV: '/generateCSV',
    GENERATE_XLSX: '/generateXlsx',
    GENERATE_CSV_FOR_ADJUSTMENT: '/generateCSVForAdjustment',
    UPLOAD_CONSUMPTIVE_VOLUME: '/uploadConsuntivoVolumi',
    UPLOAD_CONSUMPTIVE_CHARGES: '/uploadConsuntivoCharges',
    LIST_IN_ALL_SETTINGS: '/listInAllSettings',

    ANAGRAPH: {
      PROVIDER_ANAGRF: '/provider-anagraf',
      REGION_ANAGRF: '/region-anagraf',
      LOCAL_CUSTOMER_ANAGRF: '/local-customer-anagraf',
      CONTRACT_TYPE_ANAGRF: '/contract-type-anagraf',
      RESOURCE_UNITS_ANAGRF: '/resource-units-anagraf',
      SL1_ANAGRF: '/sl1-anagraf',
      SL2_ANAGRF: '/sl2-anagraf',
      SL3_ANAGRF: '/sl3-anagraf',
      SL4_ANAGRF: '/sl4-anagraf',
      SL5_ANAGRF: '/sl5-anagraf',
      UNITS_ANAGRF: '/units-anagraf',
      CURRENCY_ANAGRF: '/currency-anagraf',
      SIZE_ANAGRF: '/size-anagraf',
      SITE_ANAGRF: '/site-anagraf',
      ROLE_ANAGRF: '/role-anagraf',
      RATE_TYPE__ANAGRF: '/rate-type-anagraf',
    //  SHARENAME_DEVICE_ANAGRF: '/sharename-device-anagraf',
   //   ORGANIZATION_UNIT_ANAGRF: '/organization-unit-anagraf',
      SERVICE_VARIANT_ANAGRF: '/service-variant-anagraf'
    },

    FILTER_PAGE_REPORT: {
      CONTRACTUAL_DATA_REPORT: '/contractual-data',
      MONTHLY_ACTUAL_REPORT: '/monthly-actual',
      MONTHLY_CHARGES_REPORT: '/monthly-charges'
    }
  };

  SERVICE_REPORT_DOWNLOAD = {
    CONTRACTUAL_VALUES_SERVICE: 'ContractualValuesService',
    REIMBURSMENT_SERVICE: 'TerminationFeeService',
    TERMINATION_FEE_SERVICE: 'ReimbursmentService',
    CONSUNTIVO_VOLUMI: 'ConsuntivoVolumiService',
    CONSUNTIVO_VOLUMI_SCARTO: 'consuntivoVolumiScartoService',
    DELTA_VOLUMI: 'DeltaVolumiService',
    FORECAST_VOLUMES: 'ForecastVolumiService',
    CALCULATED_CHARGES: 'CalculatedChargesService',
    CONSUMPTIVE_CHARGES: 'ConsuntivoChargesService',
    CONSUMPTIVE_CHARGES_WASTE: 'ChargesScartoService',
    DELTA_CHARGES: 'DeltaChargesService',
  };



  ICONS = {
    CONTRACTUAL_DATA : 'assets/img/layout/left-menu-contractual-data.png',
    MONTHLY_ACTUAL : 'assets/img/layout/left-menu-monthly-actual.png',
    SERVICE_CHANGES : 'assets/img/layout/left-menu-service-changes.png',
    MONTHLY_CHARGES :  'assets/img/layout/left-menu-monthly-charges.png',
    REPORTING : 'assets/img/layout/left-menu-reporting.png',
    SETTINGS : 'assets/img/layout/left-menu-settings.png',
    MASTER_DATA : 'assets/img/layout/left-menu-anagraph.png',
    USERS: 'assets/img/layout/left-menu-users.png',
    USER: 'assets/img/layout/header-right-user.png',
    TERMINATION_FEE: 'assets/img/layout/termination-fee.png',
    PROVIDER_ANAGRF: 'assets/img/layout/provider.png',
    REGION_ANAGRF: 'assets/img/layout/region.png',
    LOCAL_CUSTOMER_ANAGRF: 'assets/img/layout/local.png',
    CONTRACT_TYPE_ANAGRF: 'assets/img/layout/clipboard.png',
    RESOURCE_UNITS_ANAGRF: 'assets/img/layout/resource.png',
    SL1_ANAGRF: 'assets/img/layout/clipboard.png',
    SL2_ANAGRF: 'assets/img/layout/clipboard.png',
    SL3_ANAGRF: 'assets/img/layout/clipboard.png',
    SL4_ANAGRF: 'assets/img/layout/clipboard.png',
    SL5_ANAGRF: 'assets/img/layout/clipboard.png',
    UNITS_ANAGRF: 'assets/img/layout/units.png',
    CURRENCY_ANAGRF: 'assets/img/layout/currency.png',
    SIZE_ANAGRF: 'assets/img/layout/size.png',
    SITE_ANAGRF: 'assets/img/layout/clipboard.png',
    ROLE_ANAGRF: 'assets/img/layout/clipboard.png',
    RATE_TYPE__ANAGRF: 'assets/img/layout/clipboard.png',
    SERVICE_VARIANT_ANAGRF: 'assets/img/layout/clipboard.png',

    SHARENAME_DEVICE_ANAGRF: 'assets/img/layout/clipboard.png',
    ORGANIZATION_UNIT_ANAGRF: 'assets/img/layout/clipboard.png',
    CANCEL:   'fa fa-times-circle',
    DETAIL:   'fas fa-search',
    DELETE:   'fas fa-trash',
    REFRESH:  'fas fa-sync-alt',
    EDIT:     'fas fa-edit',
    FALSE:    'fas fa-times',
    LEFT:     'fas fa-chevron-left',
    PLUS:     'fas fa-plus-circle',
    QUESTION: 'far fa-question-circle',
    TRUE:     'fas fa-check',
    DOWNLOAD: 'fas fa-download',
    UPLOAD:   'fas fa-upload',
    EXCEL:    'fas fa-file-excel',
    DOWNLOADING: 'fa fa-spinner fa-spin',
    DOWNLOAD_FILE: 'assets/img/layout/download-outline.png',
    FILTER_BLUE: 'assets/img/layout/filter-blue.png',
    FILTER_WHITE: 'assets/img/layout/filter-white.png',
    TRASH_RED: 'assets/img/layout//trash-red.png',
    TRASH_WHITE: 'assets/img/layout//trash-white.png',
    TRASH_DISABLE: 'assets/img/layout//trash-disable.png',

  };

  LABELS = {
    HOMEPAGE: 'Homepage',
    CONTRACTUAL_DATA : 'Contractual Data',
    MONTHLY_ACTUAL : 'Monthly Actual',
    SERVICE_CHANGES : 'Service Changes',
    MONTHLY_CHARGES : 'Monthly Charges',
    RECOVERY_MANAGEMENT : 'Recovery Management',
    REPORTING : 'Reporting',
    DASHBOARD: 'Dashboard',
    CONSOLIDATION: 'Consolidation',
    SETTINGS : 'Settings',
    CONTRACT : 'Contract',
    ANAGRAFICHE : 'Master Data',
    USERS: ' User Settings',
    TERMINATION_FEE: 'Termination Fee',
    FILTERS: 'Filters',
    LOCAL_CUSTOMER_ANAGRF : 'Local Customer',
    REGION_ANAGRF : 'Region',
    REGION_1 : 'Region 1',
    REGION_2 : 'Region 2',
    RESOURCE_UNITS_ANAGRF : 'Resource Units',
    SERVICE_VARIANT_ANAGRF: 'Service Variant',
    RESOURCE_UNITS: 'Resource Units',
    PROVIDER_ANAGRF: 'Provider',
    CONTRATTO: 'Contract',
    CHANGES_UPLOAD: 'Changes Upload',
    LOGOUT    : 'Logout',
    CONTRACT_TYPE_ANAGRF : 'Contract Type',
    EDIT_REGION : 'Edit',
    SL1_ANAGRF : 'SL1',
    SL2_ANAGRF : 'SL2',
    SL3_ANAGRF : 'SL3',
    SL4_ANAGRF : 'SL4',
    SL5_ANAGRF: 'SL5',
    UNITS_ANAGRF : 'Units',
    CURRENCY_ANAGRF: 'Currency',
    SIZE_ANAGRF: 'Size',
    SITE_ANAGRF: 'Site',
    ROLE_ANAGRF: 'Role',
    RATE_TYPE__ANAGRF: 'Rate Type',
    SHARENAME_DEVICE_ANAGRF: 'ShareName Device',
    ORGANIZATION_UNIT_ANAGRF: 'Organization Unit',

    EDIT_SERVICE_CHANGES: 'Edit',
    NEW_DELTA_VOLUMES_DET: 'New Delta Volumes Det',
    ADD_PRICE_RANGE: 'Add price range',
    REMOVE_PRICE_RANGE: 'Remove last price range',
    LAST_PRICE_RANGE: 'Last price range',
    PRICE_RANGE_SUMMARY: 'Price Range Summary',
    EDIT_LAST_PRICE_RANGE: 'Edit last price range',
    MINIMUM_VOLUME: 'Minimum Volume',
    MAXIMUM_VOLUME: 'Maximum Volume',
    PRICE_VOLUME: 'Price Volume',
    DOWNLOAD_CSV: 'Download CSV',
    DOWNLOAD_XLSX: 'Download XLSX',
    DOWNLOAD_XLSX_INSTRUCTION: 'Select Start and End Month before download:',
    CLOSE: 'Close',
    NEW: 'New',
    NEW_MASSIVE: 'New Massive',
    CONTRACTUAL_DATA_REPORT: 'Contractual Data Report',
    MONTHLY_ACTUAL_REPORT: 'Monthly Actual Report',
    MONTHLY_CHARGES_REPORT: 'Monthly Charges Report',
  };

  MENU_LIST = [
    { name: this.LABELS.CONTRACTUAL_DATA, link: this.LINKS.CONTRACTUAL_DATA, icon: this.ICONS.CONTRACTUAL_DATA },
    { name: this.LABELS.MONTHLY_ACTUAL,   link: this.LINKS.MONTHLY_ACTUAL,   icon: this.ICONS.MONTHLY_ACTUAL },
    { name: this.LABELS.SERVICE_CHANGES,  link: this.LINKS.SERVICE_CHANGES,  icon: this.ICONS.SERVICE_CHANGES },
    { name: this.LABELS.MONTHLY_CHARGES,  link: this.LINKS.MONTHLY_CHARGES,  icon: this.ICONS.MONTHLY_CHARGES },
    { name: this.LABELS.REPORTING,        link: this.LINKS.REPORTING,        icon: this.ICONS.REPORTING },
    { name: this.LABELS.DASHBOARD,        link: this.LINKS.DASHBOARD,        icon: this.ICONS.REPORTING },
    { name: this.LABELS.SETTINGS,         link: this.LINKS.SETTINGS,         icon: this.ICONS.SETTINGS },
    { name: this.LABELS.ANAGRAFICHE,      link: this.LINKS.MASTER_DATA,      icon: this.ICONS.MASTER_DATA },
    { name: this.LABELS.USERS,            link: this.LINKS.USERS,            icon: this.ICONS.USERS }
];

  DATE_FORMAT = 'dd/MM/yyyy';
  DATE_HOUR_FORMAT = 'dd/MM/yyyy HH:mm';

  PATTERNS = {
    EMAIL:      /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{1,66})\.([a-z]{2,10}(?:\.[a-z]{2})?)$/i,
    NUMBER:     /^[0-9]{1,11}$/,
    PASSWORD:   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@!%*#?^.&~`()_+|{}:<>])[A-Za-z\d$@!%*#?^.&~`()_+|{}:<>]{8,}$/,
    PHONE:      /^[0-9]{0,}$/
  };

  ANAGRAPH_LIST = [
    { name: this.LABELS.PROVIDER_ANAGRF, link: this.LINKS.ANAGRAPH.PROVIDER_ANAGRF, icon: this.ICONS.PROVIDER_ANAGRF},
    { name: this.LABELS.CONTRACT_TYPE_ANAGRF, link: this.LINKS.ANAGRAPH.CONTRACT_TYPE_ANAGRF, icon: this.ICONS.CONTRACT_TYPE_ANAGRF},
    { name: this.LABELS.REGION_ANAGRF, link: this.LINKS.ANAGRAPH.REGION_ANAGRF, icon: this.ICONS.REGION_ANAGRF},
    { name: this.LABELS.LOCAL_CUSTOMER_ANAGRF, link: this.LINKS.ANAGRAPH.LOCAL_CUSTOMER_ANAGRF, icon: this.ICONS.LOCAL_CUSTOMER_ANAGRF},
    { name: this.LABELS.RESOURCE_UNITS, link: this.LINKS.ANAGRAPH.RESOURCE_UNITS_ANAGRF, icon: this.ICONS.RESOURCE_UNITS_ANAGRF},
    { name: this.LABELS.SL1_ANAGRF, link: this.LINKS.ANAGRAPH.SL1_ANAGRF, icon: this.ICONS.SL1_ANAGRF},
    { name: this.LABELS.SL2_ANAGRF, link: this.LINKS.ANAGRAPH.SL2_ANAGRF, icon: this.ICONS.SL2_ANAGRF},
    { name: this.LABELS.SL3_ANAGRF, link: this.LINKS.ANAGRAPH.SL3_ANAGRF, icon: this.ICONS.SL3_ANAGRF},
    { name: this.LABELS.SL4_ANAGRF, link: this.LINKS.ANAGRAPH.SL4_ANAGRF, icon: this.ICONS.SL4_ANAGRF},
    { name: this.LABELS.SL5_ANAGRF, link: this.LINKS.ANAGRAPH.SL5_ANAGRF, icon: this.ICONS.SL5_ANAGRF},
    { name: this.LABELS.UNITS_ANAGRF, link: this.LINKS.ANAGRAPH.UNITS_ANAGRF, icon: this.ICONS.UNITS_ANAGRF},
    { name: this.LABELS.CURRENCY_ANAGRF, link: this.LINKS.ANAGRAPH.CURRENCY_ANAGRF, icon: this.ICONS.CURRENCY_ANAGRF},
    { name: this.LABELS.SITE_ANAGRF, link: this.LINKS.ANAGRAPH.SITE_ANAGRF, icon: this.ICONS.SITE_ANAGRF},
    { name: this.LABELS.SIZE_ANAGRF, link: this.LINKS.ANAGRAPH.SIZE_ANAGRF, icon: this.ICONS.SIZE_ANAGRF},
    { name: this.LABELS.RATE_TYPE__ANAGRF, link: this.LINKS.ANAGRAPH.RATE_TYPE__ANAGRF, icon: this.ICONS.RATE_TYPE__ANAGRF},
    { name: this.LABELS.ROLE_ANAGRF, link: this.LINKS.ANAGRAPH.ROLE_ANAGRF, icon: this.ICONS.ROLE_ANAGRF},
  { name: this.LABELS.SERVICE_VARIANT_ANAGRF, link: this.LINKS.ANAGRAPH.SERVICE_VARIANT_ANAGRF, icon: this.ICONS.SERVICE_VARIANT_ANAGRF}
  ];
  SESSION_DRAFT: EnumModel = { key: 1 };
  PLANNING_PLANNED: EnumModel = { key: 2 };

  DATE_FORMAT_DEFAULT = 'dd MMM yyyy';

  ROLE = {
    ADMIN: 'admin',
    GESTORE_LC: 'gestore_lc',
    GESTORE_CONTRACT: 'gestore_contract'
  };

  GRANTS = {
    ALL: 'ALL',
    DELETE: 'DELETE',
    EXECUTE: 'EXECUTE',
    INSERT: 'INSERT',
    SELECT: 'SELECT',
    UPDATE: 'UPDATE'
  };

  SECTIONS = {
    CONTRACTUAL_DATA: 'CONTRACTUAL_DATA',
    MONTHLY_ACTUALS: 'VOLUME_CONSUMPTIVE',
    SERVICE_CHANGES: 'SERVICE_CHANGES',
    MONTHLY_CHARGES: 'CHARGES_CONSUMPITVE',
    REPORTING: 'REPORTING',
    SETTINGS: 'SETTINGS',
    MASTER_DATA: 'MASTER_DATA',
    USER_SETTINGS: 'USER_SETTINGS'
  };


  ROLES_LIST = [
    'admin',
    'gestore_lc',
    'gestore_contract'
  ];

  OFFSET_NAME = {
    CONTRACTUAL_VALUES_OFFSET:  'contractualValuesOffset',
    TERMINATION_FEE_OFFSET: 'terminationFeeOffset',
    DISCOUNT_OFFSET: 'discountOffset',
    MINIMUM_COMMTIMENT_OFFSET: 'minimumCommitmentOffset',
    REIMBURSMENT_OFFSET:  'reimbursmentOffset',
    TRANSFORMATION_OFFSET:  'transformationOffset',
    RATE_CARD_OFFSET: 'rateCardOffset',
    DELTA_VOLUMI_OFFSET: 'deltaVolumiOffset',
    FORECAST_VOLUMI_OFFSET: 'forecastVolumiOffset',
    CONSUNTIVO_VOLUMI_OFFSET: 'consuntivoVolumiOffset',
    SCARTI_CONSUNTIVO_VOLUMI_OFFSET: 'scartiConsuntivoVolumiOffset',
    SERVICE_CHANGES_OFFSET: 'serviceChangesOffset',
    DELTA_CHARGES_OFFSET: 'deltaChargesOffset',
    CONSUMPTIVE_CHARGES_OFFSET: 'consuntivoChargesOffset',
    CALCULATED_CHARGE: 'calculatedChargeOffset',
    SCARTI_CONSUNTIVO_CHARGES_OFFSET: 'scartiConsuntivoChargesOffset',
    LOCAL_CUSTOMER_SETTING_OFFSET: 'localCustomerSettingOffset',
    CONTRACT_TYPE_SETTING_OFFSET: 'contractTypeSettingOffset',
    ARCHITECTURE_STRUCTURE_SETTING_OFFSET: 'architectureStructureSettingOffset',
    CURRENCY_SETTING_OFFSET: 'currencySettingOffset',
    CONTRACT_TYPE_OFFSET: 'contractTypeOffset',
    CURRENCY_OFFSET : 'currencyOffset',
    L1_OFFSET: 'l1Offset',
    L2_OFFSET: 'l2Offset',
    L3_OFFSET: 'l3Offset',
    LAYER_OFFSET: 'layerOffset',
    LOCAL_CUSTOMER_OFFSET: 'localCustomerOffset',
    PROVIDER_OFFSET: 'providerOffset',
    REGION_OFFSET: 'regionOffset',
    UNITS_OFFSET: 'unitsOffset',
    USER_OFFSET: 'userOffset'

  };

  static returnIsAnagraphSection(path: string): boolean {
    if (path.includes('master-data')) {
      return true;
    } else {
      return false;
    }
  }

  static parseStringIntoDate(dateString: string): Date {
    const parts = dateString.split(' ');
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');

    const day = Number(dateParts[0]), month = Number(dateParts[1]) - 1, year = Number(dateParts[2]);
    const hours = Number(timeParts[0]), minutes = Number(timeParts[1]), seconds = Number(timeParts[2]);
    return new Date(year, month, day, hours, minutes, seconds);
  }
  static returnHeader(): HttpHeaders {
    const header = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    return header;
  }

  static returnHeaderCsv(): HttpHeaders {
    return new HttpHeaders({
      'Accept': 'text/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    });
  }

  static returnHeaderBlank(): any {
    return {
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    };
  }

  static returnGeneralHeader(): any {
    return {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    };
  }

  returnIsContractSection(path: string): boolean {
   return true;
  }

  returnIsProduction() {
    return !environment.production;
  }
}
